// @flow

import { List as ImmutableList } from 'immutable';
import { mkTag } from 'data/tags/types';
import { mkChartOfAccount } from 'data/chartOfAccounts/types';

import * as types from './types';

export function transformMemorizedRuleToRequestData(memorizedRule: types.MemorizedRule) {
  return {
    id: memorizedRule.id,
    clientId: memorizedRule.clientId,
    isDeleted: memorizedRule.isDeleted,
    payee: memorizedRule.payee,
    transactionType: memorizedRule.transactionType,
    memo: memorizedRule.memo,
    amount: memorizedRule.amount,
    isNotAutoCategorized: memorizedRule.isNotAutoCategorized,
    isNotEditableByTransactions: memorizedRule.isNotEditableByTransactions,
    isExcludedFromCalendar: memorizedRule.isExcludedFromCalendar,
    coa: memorizedRule.coa ?
      {
        type: memorizedRule.coa.type,
        id: memorizedRule.coa.id,
      } :
      null,
    tags: memorizedRule.tags && memorizedRule.tags.map((tag) => ({ id: tag.id })),
    split: memorizedRule.split,
  };
}

export function transformResponseToMemorizedRules(response: any) {
  return response.data.resources.map((data) => (
    types.mkMemorizedRule({
      id: data.id,
      clientId: data.clientId,
      isDeleted: data.isDeleted,
      payee: data.payee,
      transactionType: data.transactionType,
      memo: data.memo,
      amount: data.amount,
      isNotAutoCategorized: data.isNotAutoCategorized,
      isNotEditableByTransactions: data.isNotEditableByTransactions,
      isExcludedFromCalendar: data.isExcludedFromCalendar,
      coa: data.coa ?
        mkChartOfAccount({ id: data.coa.id, type: data.coa.type }) :
        null,
      tags: data.tags ? new ImmutableList(data.tags.map((tag) => mkTag(tag))) : null,
      split: data.split,
    })
  ));
}
